import * as React from 'react';
import { Button } from '@cian/ui-kit/button';
import { PhoneContainer } from './PhoneContainer';
import { IBuilder } from '../../../types/newbuilding/builder';
import { ISeller } from '../../../types/newbuilding/seller';

interface IContactsListCallButtonProps {
  onClick(): void;
  beforeIcon?: React.JSX.Element;
  buttonText: string;
  contact: IBuilder | ISeller;
}

export const ContactsListCallButton = ({ onClick, beforeIcon, buttonText, contact }: IContactsListCallButtonProps) => {
  const [phoneVisible, setPhoneVisible] = React.useState(false);

  const onButtonClick = React.useCallback(() => {
    onClick();
    setPhoneVisible(true);
  }, [onClick]);

  if (phoneVisible) {
    return <PhoneContainer contact={contact} placeType="Promo" />;
  }

  return (
    <Button
      data-testid="ContactsListCallButton"
      theme="fill_primary"
      size="M"
      beforeIcon={beforeIcon}
      onClick={onButtonClick}
      tabIndex={-1}
    >
      {buttonText}
    </Button>
  );
};
